// Types
import type { Table } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';

import type { UserPublicTokenType } from '@/utils/hooks/swr/integrations/useUserPublicTokens';
// Hooks
import useUserRole from '@/utils/hooks/user/useUserRole';

import ButtonDeleteToken from '@/components/pages/settings/integrations/ApiAccessTable/Actions/ButtonDeleteToken';
// Components
import ButtonEditToken from '@/components/pages/settings/integrations/ApiAccessTable/Actions/ButtonEditToken';

type TableBodyProps = {
    table: Table<UserPublicTokenType>;
};

function TableBody({ table }: TableBodyProps) {
    const { isTeamMember } = useUserRole();
    return (
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="bg-icoGray-100 dark:bg-icoDarkMode-deepBlack">
                    {row.getVisibleCells().map((cell) => (
                        <td className="whitespace-nowrap px-6 py-3.5 first:pl-12" key={cell.id}>
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                    ))}
                    {!isTeamMember ? (
                        <td className="w-28">
                            <span className="flex items-center gap-5 pl-6 pr-12">
                                <ButtonEditToken token={row.original} />
                                <ButtonDeleteToken token={row.original} />
                            </span>
                        </td>
                    ) : null}
                </tr>
            ))}
        </tbody>
    );
}

export default TableBody;
